import { isAuth } from "../../helpers/cookies";
export const FORGOT_PASSWORD_REQUEST_URL = "users/forgot-password";
export const RESET_PASSWORD_URL = "users/reset-password";
// export const GET_USER_COMPANY_LIST_URL = `user/${isAuth()?.user_id}/company`; // Dynamic constants are dangerous at module level
export const CHANGE_PASSWORD_URL = 'users/change_password';
export const REGISTER_URL = 'users/register';
export const COMPANY_URL = 'company';
export const PROCESS_URL = 'process';
export const STAGE_URL = 'stage';
export const GET_COMPANY_DETAILS = "/details";
export const GET_USERS_URL = "users";
export const GET_USERS_REP_DROPDOWN_URL = "users/rep-dropdown";